import { PageNumber } from "accessNumbers";
import { GeneralCode } from "models/content/GeneralCode";
import { MyRoute } from "routes";
export class BoRole {
  id: number;
  roleName: string;
  permissions: Permission;
  description: string;
  created: Date;
  type: GeneralCode;
  createdBy: number;
  brandId: number;
  isManager: boolean;
}

export class Permission {
  pages: number[];
  controls: Control[];

  hasAccess(page: PageNumber, control: PermissionType): boolean {
    // if (location.hostname === "localhost") {
    //   return true;
    // }
    const pageId = this.pages?.find((p) => p == page);
    if (!pageId) {
      return false;
    }
    const controlId = this.controls.filter(x=>x).find(
      (c) => c.page == page && c.access.includes(control)
    );
    return !!controlId;
  }

  hasAccessPage(accessNumber?:PageNumber):boolean{
    if (accessNumber === 0){
      return true;
    }
    return this.pages?.includes(accessNumber || 0);
  }
}

export class Control {
  page: number;
  access: PermissionType[];
}

export enum PermissionType {
  Access = 99,
  Edit = 100,
  AddNew = 101,
  Delete = 102,
  Duplicate = 103,
  AskToPublish = 105,
  Publish = 106,
  Host = 107,
  Lang = 108,
  ViewAllOptions = 109,

  
  Manager = 200
}
